<app-overlay-message></app-overlay-message>
<div
  class="admin-dashboard"
  [ngClass]="{ 'fade-admin-dashboard': addUser || editUser || resetPassword }"
>
  <!-- Header Section -->
  <header class="header">
    <div class="content-header">
      <h1>Admin Dashboard</h1>
    </div>

    <div class="header-right">
      <button class="add-user-button" (click)="onAddUser()">
        <span>+ Add User</span>
      </button>
    </div>
  </header>

  <!-- Content Section -->
  <div class="body-container">
    <h2>User Management</h2>

    <div class="tableWrap">
      <table class="user-table">
        <thead class="table-header">
          <tr>
            <th>
              Name
              <span
                ><img
                  src="../../../assets/sortAdmin.png"
                  alt="sort"
                  class="sort-name-icon"
                  (click)="toggleSortByName()"
              /></span>
            </th>

            <th>Username</th>
            <th>Added By</th>
            <th>
              Added On
              <span
                ><img
                  src="../../../assets/sortAdmin.png"
                  alt="sort"
                  class="sort-name-icon-reset"
                  (click)="toggleSortByAddedOn()"
              /></span>
            </th>
            <th
              class="account-status"
              (click)="toggleStatusFilterPopup($event)"
            >
              Account Status
              <span>
                <img
                  src="../../../assets/AdminFilter.png"
                  alt="adminfiltericon"
                />
              </span>
              <div
                class="status-filter-popup"
                *ngIf="showStatusFilterPopup"
                (click)="$event.stopPropagation()"
              >
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="statusFilter.active"
                    (change)="filterUsers()"
                  />
                  Active
                </label>
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="statusFilter.inactive"
                    (change)="filterUsers()"
                  />
                  Inactive
                </label>
              </div>
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of displayedUsers; let i = index">
         
            <td >
              {{ user.name }}
              <div class="uname-container">
              <span class="admin-label" *ngIf="user.isAdmin">Admin</span>
            </div>
            </td>
         
        
            <td>{{ user.username }}</td>
            <td>{{ user.added_by || "—" }}</td>
            <td>{{ formatDate(user.added_on) }}</td>
            <td>
              <span
                class="status"
                [ngClass]="{
                  active: user.isUserActive,
                  inactive: !user.isUserActive
                }"
              >
                {{ user.isUserActive ? "Active" : "Inactive" }}
              </span>
            </td>
            <td class="action-btn-container">
              <button class="action-button-edit" (click)="onEditUser(i)">
                <span
                  ><img
                    src="../../../assets/Admin-Edit-User.png"
                    alt="edituser"
                /></span>
              </button>
              <button
                [ngClass]="
                  resetButtonEnablement(i)
                    ? 'action-button-reset-disable'
                    : 'action-button-reset'
                "
                (click)="onResetUser(i)"
                [disabled]="resetButtonEnablement(i)"
              >
                <span
                  ><img
                    src="../../../assets/Admin-Password-Lock.png"
                    alt="password-reset"
                /></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Table Footer with Pagination -->
    <div class="pagination-container">
      <div class="pagination-info">
        <span>
          Page
          <input
            class="pagination-input"
            type="number"
            [(ngModel)]="currentPage"
            (change)="goToPage(currentPage)"
            [min]="1"
            [max]="getTotalPages()"
          />
        </span>
        <div class="pagination-controls">
          <button
            class="pagination-button"
            [disabled]="currentPage === 1"
            (click)="goToPage(currentPage - 1)"
          >
            &lt;
          </button>
          <button
            *ngFor="let page of [].constructor(getTotalPages()); let i = index"
            [ngClass]="{
              'active-page': i + 1 === currentPage,
              'non-active-page': i + 1 !== currentPage
            }"
            (click)="goToPage(i + 1)"
          >
            {{ i + 1 }}
          </button>
          <button
            class="pagination-button"
            [disabled]="currentPage === getTotalPages()"
            (click)="goToPage(currentPage + 1)"
          >
            &gt;
          </button>
        </div>
      </div>

      <div class="items-per-page">
        <span class="Textpagination">
          {{ (currentPage - 1) * itemsPerPage + 1 }}-{{ getEndingIndex() }} of
          {{ totalUsers }}
        </span>
        <select
          class="select-items-per-page"
          [(ngModel)]="itemsPerPage"
          (change)="onItemsPerPageChange()"
        >
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- **********************************8 add user modal starts -->
<div class="modal-overlay" *ngIf="addUser">
  <div class="first-login-container">
    <div class="modal-header">
      <h2>Add User</h2>
      <span>
        <img
          (click)="closeModal()"
          src="../../../assets/admin-close-cross.png"
        />
      </span>
    </div>

    <hr />
    <p>Enter user details as required.</p>

    <form [formGroup]="addUserForm" (ngSubmit)="onSubmitAddUser()">
      <div class="form-group-container">
        <!-- First Row: Name input -->
        <div class="form-row">
          <div class="form-group">
            <label for="name" [ngClass]="{ invalid: isFieldInvalid('name') }"
              >Name</label
            >
            <input
              type="text"
              id="name"
              formControlName="name"
              placeholder="Enter full name"
            />
          </div>
        </div>

        <!-- Second Row: Username and Password -->
        <div class="form-row">
          <div class="form-group">
            <label
              for="username"
              [ngClass]="{ invalid: isFieldInvalid('username') }"
              >Username</label
            >
            <input
              [disabled]="editUser"
              type="text"
              id="username"
              formControlName="username"
              placeholder="Enter username"
            />
          </div>

          <div class="form-group password-generator-container">
            <label
              for="password"
              [ngClass]="{ invalid: isFieldInvalid('password') }"
              >Password
              <span class="tooltip-container">
                <img
                  src="../../../assets/passwordInfo.png"
                  alt="password info"
                />
                <span class="tooltip-text">
                  Password must be 8 to 15 characters.<br />
                  At least one uppercase letter is required.<br />
                  At least one lowercase letter is required.<br />
                  At least one digit is required.<br />
                  At least one special character is required.
                </span>
              </span></label
            >
            <div class="password-wrapper">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="passwordInput"
                class="password-generator-input"
                formControlName="password"
                placeholder="Enter password"
              />

              <!-- Generate Password -->
              <span
                *ngIf="showGenerateText"
                id="generateText"
                class="generate-text"
                (click)="generatePassword()"
                >Generate</span
              >

              <!-- Eye Icon (Show Password) -->
              <span
                *ngIf="showEyeIcon"
                class="toggle-password"
                (click)="togglePasswordVisibility()"
              >
                <img
                  src="../../../assets/passwordEye.png"
                  alt="Show Password"
                />
              </span>

              <!-- Copy Password Icon -->
              <span
                *ngIf="showCopyIcon"
                class="copy-password"
                (click)="copyPassword()"
              >
                <img
                  src="../../../assets/passwordCopy.png"
                  alt="Copy Password"
                />
              </span>
            </div>
          </div>
        </div>

        <!-- Third Row: Account Status and Project Role -->
        <div class="form-row">
          <div class="form-group">
            <label for="account-status">Account Status</label>
            <select id="account-status" formControlName="accountStatus">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div class="form-group">
            <label for="project-role">Project Role</label>
            <select id="project-role" formControlName="projectRole">
              <option value="admin">Admin</option>
              <option value="user">User</option>
            </select>
          </div>
        </div>
      </div>

      <hr />
      <!-- Buttons: Cancel and Confirm aligned to the right -->
      <div class="bottom-divider">
        <button type="button" class="cancel-button" (click)="closeModal()">
          Cancel
        </button>
        <button
          type="submit"
          class="confirm-button"
          [disabled]="addUserForm.invalid"
        >
          Confirm
        </button>
      </div>
    </form>
  </div>
</div>

<!-- 8***************************edit************ -->

<!-- Edit User Modal -->
<div class="modal-overlay-edit" *ngIf="editUser">
  <div class="first-login-container">
    <div class="modal-header">
      <h2>Edit User</h2>
      <span>
        <img
          (click)="closeModal()"
          src="../../../assets/admin-close-cross.png"
        />
      </span>
    </div>
    <hr />
    <!-- Edit User Form -->
    <form [formGroup]="editUserForm" (ngSubmit)="onSubmitEndUser()">
      <div class="form-group-container">
        <!-- First Row: Username and Name -->
        <div class="form-row">
          <div class="form-group">
            <label for="username">Username</label>
            <input
              type="text"
              id="username"
              formControlName="username"
              placeholder="Enter username"
            />
          </div>
          <div class="form-group">
            <label for="name" [ngClass]="{ invalid: isFieldInvalid('name') }"
              >Name</label
            >
            <input
              type="text"
              id="name-edit"
              formControlName="name"
              placeholder="Enter full name"
            />
          </div>
        </div>
        <!-- Second Row: Account Status and Project Role -->
        <div class="form-row">
          <div class="form-group">
            <label for="account-status">Account Status</label>
            <select id="account-status" formControlName="accountStatus">
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div class="form-group">
            <label for="project-role">Project Role</label>
            <select id="project-role" formControlName="projectRole">
              <option value="Admin">Admin</option>
              <option value="User">User</option>
            </select>
          </div>
        </div>
      </div>
      <hr />
      <!-- Buttons: Cancel and Confirm -->
      <div class="bottom-divider">
        <button type="button" class="cancel-button" (click)="closeModal()">
          Cancel
        </button>
        <button
          type="submit"
          class="confirm-button"
          [disabled]="!isFormChanged || !isEditFormValid()"
        >
          Confirm
        </button>
      </div>
    </form>
  </div>
</div>

<!-- ************************reset password modal****************** -->

<div class="modal-overlay-reset" *ngIf="resetPassword">
  <div class="first-login-container">
    <div class="modal-header">
      <h2>Reset Password</h2>
      <span>
        <img
          (click)="closeModal()"
          src="../../../assets/admin-close-cross.png"
        />
      </span>
    </div>
    <hr />

    <form [formGroup]="resetPasswordForm" (ngSubmit)="resetOnSubmit()">
      <div class="form-group-container">
        <div class="form-group-reset">
          <div>
            <label for="username">Username</label>
            <input
              [readonly]="true"
              id="username"
              type="text"
              formControlName="username"
            />
          </div>
          <!-- <div>
            <label for="newPassword">New Password</label>
            <input id="newPassword" type="password" formControlName="newPassword" />
          </div> -->
          <div class="form-group password-generator-container">
            <label
              for="newPassword"
              [ngClass]="{ invalid: isFieldInvalid('newPassword') }"
            >
              New Password
              <span class="tooltip-container">
                <img
                  src="../../../assets/passwordInfo.png"
                  alt="password info"
                />
                <span class="tooltip-text">
                  Password must be 8 to 15 characters.<br />
                  At least one uppercase letter is required.<br />
                  At least one lowercase letter is required.<br />
                  At least one digit is required.<br />
                  At least one special character is required.
                </span>
              </span>
            </label>

            <div class="password-wrapper">
              <input
                [type]="showResetPassword ? 'text' : 'password'"
                id="resetPasswordInput"
                class="password-generator-input"
                formControlName="newPassword"
                placeholder="Enter new password"
              />

              <!-- Generate Password -->
              <span
                *ngIf="showResetGenerateText"
                id="generateResetText"
                class="generate-text"
                (click)="generatePassword(true)"
                >Generate</span
              >

              <!-- Eye Icon (Show Password) -->
              <span
                *ngIf="showResetEyeIcon"
                class="toggle-password"
                (click)="togglePasswordVisibility(true)"
              >
                <img
                  src="../../../assets/passwordEye.png"
                  alt="Show Password"
                />
              </span>

              <!-- Copy Password Icon -->
              <span
                *ngIf="showResetCopyIcon"
                class="copy-password"
                (click)="copyPassword(true)"
              >
                <img
                  src="../../../assets/passwordCopy.png"
                  alt="Copy Password"
                />
              </span>
            </div>
          </div>
        </div>

        <hr />

        <div class="bottom-divider-reset">
          <button type="button" class="cancel-button" (click)="closeModal()">
            Cancel
          </button>
          <button
            type="submit"
            class="confirm-button"
            (click)="resetOnSubmit()"
          >
            Confirm
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
